import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'hammerjs';


import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

//https://stackoverflow.com/questions/35721206/how-to-enable-production-mode
if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
